import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-20 border-b-2 border-black bg-white overflow-hidden" data-id="element-136">
      {/* Grid Background */}
      <div className="absolute inset-0 grid-bg opacity-100 pointer-events-none" data-id="element-137"></div>

      <div className="container mx-auto px-0 relative z-10 grid grid-cols-1 lg:grid-cols-12 h-full min-h-[80vh]" data-id="element-138">
        {/* Left Content */}
        <div className="lg:col-span-7 flex flex-col justify-center p-8 lg:p-16 border-b-2 lg:border-b-0 lg:border-r-2 border-black bg-white" data-id="element-139">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5
        }} className="mb-8" data-id="element-140">
            <span className="inline-block px-4 py-1 border-2 border-black font-bold text-xs uppercase tracking-widest bg-swiss-red text-white shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]" data-id="element-141">
              Est. 2013
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-6xl md:text-8xl lg:text-9xl font-heading font-black text-black uppercase leading-[0.85] tracking-tighter mb-8" data-id="element-142">
            Design
            <br data-id="element-143" />
            <span className="text-transparent text-stroke-black" data-id="element-144">That</span>
            <br data-id="element-145" />
            Works
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-xl md:text-2xl text-black font-medium max-w-xl mb-12 leading-tight" data-id="element-146">
            We are a digital design studio crafting bold experiences for
            forward-thinking brands. No fluff, just impact.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-wrap gap-4" data-id="element-147">
            <Button size="lg" className="shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] active:translate-x-[4px] active:translate-y-[4px] active:shadow-none" data-id="element-148">
              View Projects
            </Button>
            <Button variant="outline" size="lg" className="shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] active:translate-x-[4px] active:translate-y-[4px] active:shadow-none" data-id="element-149">
              Contact Us
            </Button>
          </motion.div>
        </div>

        {/* Right Visual */}
        <div className="lg:col-span-5 relative bg-swiss-gray flex items-center justify-center overflow-hidden border-b-2 lg:border-b-0 border-black" data-id="element-150">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1550684848-fac1c5b4e853?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center grayscale contrast-125 mix-blend-multiply opacity-50" data-id="element-151"></div>

          <div className="relative z-10 w-full h-full flex flex-col justify-between p-8" data-id="element-152">
            <div className="self-end w-32 h-32 bg-swiss-red rounded-full mix-blend-multiply animate-pulse" data-id="element-153"></div>
            <div className="self-start w-48 h-48 border-4 border-black rounded-full flex items-center justify-center" data-id="element-154">
              <ArrowRight size={64} className="text-black -rotate-45" data-id="element-155" />
            </div>
          </div>

          {/* Marquee */}
          <div className="absolute bottom-0 left-0 right-0 bg-swiss-red border-t-2 border-black py-3 overflow-hidden whitespace-nowrap" data-id="element-156">
            <div className="animate-marquee inline-block" data-id="element-157">
              <span className="text-white font-black uppercase text-xl mx-4" data-id="element-158">
                Strategy • Branding • Design • Development • Marketing •
                Strategy • Branding • Design • Development • Marketing •
              </span>
              <span className="text-white font-black uppercase text-xl mx-4" data-id="element-159">
                Strategy • Branding • Design • Development • Marketing •
                Strategy • Branding • Design • Development • Marketing •
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}